import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';

export enum TriggerCoverage {
  existing = 'existing',
  new = 'new',
  all = 'all',
}

export enum TriggerType {
  violations = 'violations',
  resources = 'resources',
}

// Mapping needed as the old playbook triggers component, a few other places, and backend depend on the single `TriggerTypes` value.
// The distinction between "trigger type" and "trigger coverage" is purely an intuitive way of displaying/selecting the trigger in the UI.
// Behind the scenes it's just a single, combined value. This mapping is used to convert between the two.

const TRIGGER_MAPPING: {
  forward: Record<TriggerTypes, { coverage: TriggerCoverage; type: TriggerType }>;
  reverse: Record<TriggerCoverage, Record<TriggerType, TriggerTypes>>;
} = {
  forward: {
    [TriggerTypes.existingViolationFound]: { coverage: TriggerCoverage.existing, type: TriggerType.violations },
    [TriggerTypes.existingResourceFound]: { coverage: TriggerCoverage.existing, type: TriggerType.resources },
    [TriggerTypes.newViolationFound]: { coverage: TriggerCoverage.new, type: TriggerType.violations },
    [TriggerTypes.newResourceFound]: { coverage: TriggerCoverage.new, type: TriggerType.resources },
    [TriggerTypes.newOrExistingViolationFound]: { coverage: TriggerCoverage.all, type: TriggerType.violations },
    [TriggerTypes.newOrExistingResourceFound]: { coverage: TriggerCoverage.all, type: TriggerType.resources },
  } satisfies Record<TriggerTypes, { coverage: TriggerCoverage; type: TriggerType }>,
  reverse: {
    [TriggerCoverage.existing]: {
      [TriggerType.violations]: TriggerTypes.existingViolationFound,
      [TriggerType.resources]: TriggerTypes.existingResourceFound,
    },
    [TriggerCoverage.new]: {
      [TriggerType.violations]: TriggerTypes.newViolationFound,
      [TriggerType.resources]: TriggerTypes.newResourceFound,
    },
    [TriggerCoverage.all]: {
      [TriggerType.violations]: TriggerTypes.newOrExistingViolationFound,
      [TriggerType.resources]: TriggerTypes.newOrExistingResourceFound,
    },
  },
};

export function getCombinationFromTriggerTypes(triggerType: TriggerTypes): {
  coverage: TriggerCoverage;
  type: TriggerType;
} {
  return TRIGGER_MAPPING.forward[triggerType];
}

export function getTriggerTypesFromCombination(coverage: TriggerCoverage, type: TriggerType): TriggerTypes {
  return TRIGGER_MAPPING.reverse[coverage][type];
}
